import { connect } from 'react-redux'
import ShareButton, { ShareButtonDispatchProps, ShareButtonOwnProps } from 'components/features/pfm/ShareButton/ShareButton'
import { registerShareActionCreator } from 'actions/socialActions'

const mapDispatchToProps: ShareButtonDispatchProps = {
  onShare: registerShareActionCreator,
}

const ShareButtonContainer = connect<
  {},
  ShareButtonDispatchProps,
  ShareButtonOwnProps
>(undefined, mapDispatchToProps)(ShareButton)

export default ShareButtonContainer
